/// <amd-module name="VC/Banner/repo-banner-service" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { GitRepository } from "Repos/Common/Contracts/Git";
import { IVCViewModelDataProviderService } from "Repos/Common/VCViewModelDataProviderService";
import { IGlobalMessagesService, IGlobalMessageBanner } from "TFS/GlobalBanner/GlobalMessagesService.Types";


export interface IRepoBannerService extends IVssService {
    showBanner(): void;
}

const messageDataProviderId = "ms.vss-code-web.git-repo-banner-message-data-provider";

class RepoBannerService extends VssService implements IRepoBannerService {
    public async showBanner() {
        try {
            const repo = await this._getRepository();
            if (repo && repo.isInMaintenance)
            {
                const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
                const banner: IGlobalMessageBanner | undefined = contributionService.getData<IGlobalMessageBanner>(messageDataProviderId);
                if(banner) {
                    this._createMaintenanceBanner(banner);
                }
            }
        } catch (error) {
            this._recordTelemetry(error);
        }
    }


    private _createMaintenanceBanner(banner: IGlobalMessageBanner) {
        const messageService = this.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
        messageService.addBanner(banner, true);
    }

    private _recordTelemetry(error: Error) {
        this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService").publishEvent(
            "ComponentGovernance",
            "RepositoryHubBanner",
            { "error": error }
        );
    }

    private async _getRepository(): Promise<GitRepository|undefined> {
        const contributionService = this.pageContext.getService<IVCViewModelDataProviderService>("IVCViewModelDataProviderService");
        const data = contributionService.getRepository();
        return data;
    }
}

Services.add("IRepoBannerService", { serviceFactory: RepoBannerService });
